function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M28.672 27.649c0-7.093-5.752-12.844-12.848-12.844-7.095 0-12.848 5.75-12.848 12.844 0 7.092 5.753 12.843 12.848 12.843 7.096 0 12.848-5.751 12.848-12.843z",
  stroke: "#FFD4C7",
  strokeWidth: 5.362
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.605 26.335c-.657-6.476-6.129-11.53-12.781-11.53-7.095 0-12.848 5.75-12.848 12.843S8.73 40.491 15.824 40.491c1.185 0 2.334-.16 3.424-.461",
  stroke: "#FFD4C7",
  strokeWidth: 5.362
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.417 10.425L79.08 51.78l-19.053 5.61L52.1 76.936 13.437 35.58l.218-6.251 20.508-19.122 6.254.217z",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Discount_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.504 7.275h71.508V79.87H10.504V7.275z",
  fill: "#FF5636"
}));

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.425 23.865a2.45 2.45 0 112.42 4.264 2.452 2.452 0 11-2.42-4.264z",
  fill: "#fff"
});

var _ref6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Discount_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.25 20.612h10.771V31.38h-10.77V20.61z",
  fill: "#fff"
}));

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.08 57.372l-.053.017-7.925 19.546-38.664-41.35c.087-2.442.13-3.814.217-6.255l9.508-8.87 3.78 3.779a2.43 2.43 0 00-.443 2.971 2.458 2.458 0 003.345.92c.218-.12.4-.268.557-.434l29.677 29.676z",
  fill: "#fff"
});

var _ref8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Discount_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.505 17.528h52.507v62.34H10.505v-62.34z",
  fill: "#BF3939"
}));

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.71 24.23a2.339 2.339 0 112.28 4.086 2.34 2.34 0 01-2.28-4.086z",
  fill: "#fff"
});

var _ref10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Discount_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M28.874 27.864c0-6.77-5.489-12.26-12.26-12.26-6.77 0-12.259 5.49-12.259 12.26s5.49 12.259 12.26 12.259 12.259-5.49 12.259-12.26z",
  stroke: "#FFD4C7",
  strokeWidth: 5.362
}));

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M35.225 39.515a1.688 1.688 0 102.387 2.386 1.688 1.688 0 00-2.387-2.386zm5.133 5.132a5.572 5.572 0 01-7.877 0 5.567 5.567 0 010-7.876 5.572 5.572 0 017.877 0 5.568 5.568 0 010 7.876z",
  fill: "#fff"
});

var _ref12 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Discount_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.916 32.208h17.007v17.003H27.916V32.208z",
  fill: "#002F34"
}));

var _ref13 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M48.727 30.319l-5.248 5.245-1.912-1.912 5.247-5.246 1.913 1.913z",
  fill: "#fff"
});

var _ref14 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Discount_svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M38.634 25.474h13.025v13.023H38.634V25.474z",
  fill: "#002F34"
}));

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M41.914 51.19s12.441.699 12.243-13.49",
  stroke: "#003035",
  strokeWidth: 6.335
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M40.14 14.442L72.917 49.5 56.99 54.044l-6.474 16.341L17.74 35.326l.128-5.245 17.027-15.876 5.245.237z",
  stroke: "#fff",
  strokeWidth: 1.751
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M28.43 25.76c-.848-6.262-6.217-11.09-12.714-11.09-4.027 0-7.62 1.856-9.973 4.757",
  stroke: "#FFD4C7",
  strokeWidth: 5.362
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M50.283.955l5.074.998-2.103 10.684-5.074-.998L50.283.955z",
  fill: "#fff"
});

var _ref19 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Discount_svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M45.247-1.978H58.29V15.57H45.247V-1.978z",
  fill: "#FFCE32"
}));

var _ref20 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M63.676 16.456l7.71-7.687 3.65 3.66-7.71 7.685-3.65-3.658z",
  fill: "#fff"
});

var _ref21 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Discount_svg__h)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M60.744 5.837h17.225v17.21H60.744V5.838z",
  fill: "#FFCE32"
}));

var _ref22 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.346 30.723l10.687-2.101.996 5.068-10.687 2.1-.996-5.067z",
  fill: "#fff"
});

var _ref23 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#Discount_svg__i)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M68.413 25.69h17.549v13.034H68.413V25.69z",
  fill: "#FFCE32"
}));

const SvgDiscount = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 84,
  height: 77,
  fill: "none"
}, props), _ref, _ref2, /*#__PURE__*/React.createElement("mask", {
  id: "Discount_svg__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 13,
  y: 10,
  width: 67,
  height: 67
}, _ref3), _ref4, /*#__PURE__*/React.createElement("mask", {
  id: "Discount_svg__b",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 26,
  y: 23,
  width: 6,
  height: 6
}, _ref5), _ref6, /*#__PURE__*/React.createElement("mask", {
  id: "Discount_svg__c",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 13,
  y: 20,
  width: 48,
  height: 57
}, _ref7), _ref8, /*#__PURE__*/React.createElement("mask", {
  id: "Discount_svg__d",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 26,
  y: 23,
  width: 6,
  height: 6
}, _ref9), _ref10, /*#__PURE__*/React.createElement("mask", {
  id: "Discount_svg__e",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 30,
  y: 35,
  width: 12,
  height: 12
}, _ref11), _ref12, /*#__PURE__*/React.createElement("mask", {
  id: "Discount_svg__f",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 41,
  y: 28,
  width: 8,
  height: 8
}, _ref13), _ref14, _ref15, _ref16, _ref17, /*#__PURE__*/React.createElement("mask", {
  id: "Discount_svg__g",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 48,
  y: 0,
  width: 8,
  height: 13
}, _ref18), _ref19, /*#__PURE__*/React.createElement("mask", {
  id: "Discount_svg__h",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 63,
  y: 8,
  width: 13,
  height: 13
}, _ref20), _ref21, /*#__PURE__*/React.createElement("mask", {
  id: "Discount_svg__i",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 71,
  y: 28,
  width: 13,
  height: 8
}, _ref22), _ref23);

export default SvgDiscount;